import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    } else {
      navigate('/');
      setTimeout(() => {
        document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
      }, 150);
    }
  };

  return (
    <footer className="border-t border-stone-200 bg-white">
      <div className="px-4 py-12 md:px-6">
        <div className="mx-auto grid max-w-7xl grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2 whitespace-nowrap font-display text-lg font-bold text-stone-900">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-emerald-600 text-white">
                <i className="ri-links-line text-lg"></i>
              </span>
              <span>{t('brand')}</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-stone-500">{t('footer.tagline')}</p>
            <p className="mt-3 text-sm leading-relaxed text-stone-400">{t('footer.disclaimer')}</p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-stone-900">{t('footer.navTitle')}</h4>
            <ul className="mt-4 space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-stone-600 transition-colors hover:text-emerald-700">
                  {t('nav.home')}
                </Link>
              </li>
              <li>
                <button type="button" onClick={() => scrollTo('spreadsheet')} className="text-sm text-stone-600 transition-colors hover:text-emerald-700">
                  {t('nav.spreadsheet')}
                </button>
              </li>
              <li>
                <Link to="/usfans-spreadsheet-guide" className="text-sm text-stone-600 transition-colors hover:text-emerald-700">
                  {t('nav.guide')}
                </Link>
              </li>
              <li>
                <button type="button" onClick={() => scrollTo('safety')} className="text-sm text-stone-600 transition-colors hover:text-emerald-700">
                  {t('nav.safety')}
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-stone-900">{t('footer.categoriesTitle')}</h4>
            <ul className="mt-4 grid grid-cols-1 gap-2.5">
              {categories.slice(0, 7).map((cat) => (
                <li key={cat.key}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-stone-600 transition-colors hover:text-emerald-700"
                  >
                    {t(`categories.${cat.key}`)}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-stone-900">{t('footer.legalTitle')}</h4>
            <ul className="mt-4 space-y-2.5">
              {(t('footer.legalLinks', { returnObjects: true }) as unknown as string[]).map((label: string) => (
                <li key={label}>
                  <span className="text-sm text-stone-400">{label}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mx-auto mt-10 flex max-w-7xl flex-col items-center justify-between gap-3 border-t border-stone-100 pt-6 sm:flex-row">
          <p className="text-xs text-stone-400">
            © {new Date().getFullYear()} {t('brand')}. {t('footer.copyright')}
          </p>
          <p className="text-xs text-stone-400">usfanslink.click</p>
        </div>
      </div>
    </footer>
  );
}